import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import Axios from 'axios';
import MeetingModule from "../../components/MeetingModule";
import { Container } from "reactstrap";
import { systemLabelActions } from "../../../../../store/actions/system/systemLabel/systemLabel.action";
import EditorSidebar from "../../../../components/editor/EditorSidebar/EditorSidebar";
import { AppAside } from "@coreui/react";
import { cmsActions } from "../../../../../store/actions/cms/cms.action";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import TemplateWrapper from "../../../template/containers/TemplateLayout/TemplateWrapper";
import { DragDropContext } from "react-dnd";


class MeetingEditorLayout extends React.Component {
    state = {
        modules: []
    };
    componentDidMount() {
        const { dispatch, user, match } = this.props;
        if (user) {
            const eventId = match.params.id;
            const userLang = user.userLang === undefined ? user.token.userLang : user.userLang;
            dispatch(cmsActions.setEnviroment(sourceTypes.MEETING, true, eventId));
            /*            dispatch(templateActions.getDefaultTemplateByEvent(eventId)); */
            this.getModules(eventId)
            if (user && userLang) {
                dispatch(systemLabelActions.getGroup(user.userLang, "Meeting.Edit"));
            }
        }
    }
    getModules = (eventId) => {
        Axios.get(`/api/meeting/${eventId}`)
            .then(res => {
                console.log(res.data)
                if (res.data.length > 0) {
                    this.setState({
                        modules: res.data,
                    })
                }
            })
            .catch(err => {
                console.error(err)
            })
    }
    deleteModule = (id) => {
        if (!id) return;
        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        };

        return fetch(`/api/meeting/deletemodule/${id}`, requestOptions)
            .then(res => res.json())
            .then(data => {
                const modules = Array.from(
                    this.state.modules.filter(m => m.digitalMeetingItemId !== data.deletedId)
                )
                this.setState({ modules });
                this.hubConnection
                    .invoke("updateMeetingLayout", modules, this.state.eventId)
                    .catch((err) => {
                        this.onError(err);
                    });
            });
    }
    updateMeetingLayout = (modules) => {
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(modules),
        };

        return fetch(`/api/meeting/`, requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    modules: data,
                })
                /*   this.hubConnection
                      .invoke("updateMeetingLayout", modules, this.state.eventId)
                      .catch((err) => {
                          this.onError(err);
                      }); */
                /*  setModules(data);
                 setLoading(false);
                 setHasChanged(false);
                 props.updateMeetingLayout(data) */
                /*  console.log(data) */
            });

    };

    onChange = (prop, id, settings) => {
        const modules = Array.from(this.state.modules)
        const index = modules.indexOf(modules.find(m => m.digitalMeetingItemId == id));
        if (index > -1) {
            if (prop === 'size') {
                modules[index].width = settings.width;
                modules[index].height = settings.height;
            }
            else if (prop === 'position') {
                modules[index].x = settings.x;
                modules[index].y = settings.y;
            }
            this.setState({ modules })
        }
    }



    render() {
        const { alert, page, template } = this.props;
        const { modules } = this.state;
        /*   const { content } = template.template; */
        return (
            <React.Fragment>
                <div className="app form-editmode">
                    <div className="app-body" style={{ marginTop: "0px" }} />
                    <AppAside
                        className="editor-aside"
                        fixed
                        display="lg"
                        style={{ width: "320px" }}
                        className={"aside-show"}
                    >
                        <div ref={r => this.asideEditorRef = r}>
                            <EditorSidebar
                                toggleConditionModal={this.toggleConditionModal}
                            />
                        </div>
                    </AppAside>
                    <main
                        style={{ marginLeft: "320px" }}
                        className=" not-inflicted editor-content"
                    >
                        <div className="animated fadeIn">
                            <Container fluid style={{ padding: "0px" }}>
                                <div id="meeting-grid" style={{ width: '100%', height: '100vh', position: 'relative' }}>
                                    {modules.length > 0 ? modules.filter(m => m.visible == true).map((m, i) => {
                                        return (
                                            <React.Fragment key={i}>
                                                <MeetingModule onChange={this.onChange} name={m.name} module={m} position={{ zIndex: m.z, x: m.x, y: m.y }} size={{ height: m.height, width: m.width }} />
                                            </React.Fragment>
                                        )
                                    }) : null}
                                </div>
                            </Container>
                        </div>
                    </main >
                </div >
            </React.Fragment >
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    return {
        user,
        alert: state.alert,
        page: state.page,
        template: state.template,
        language: state.language,
        systemLabel: state.systemLabel
    };
}
export default connect(mapStateToProps)(MeetingEditorLayout);
